import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import store from '@/store/mainStore';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
	{
		path: '/',
		redirect: '/patients'
	},
	{
		path: '/index',
		redirect: '/patients'
	},
	{
		path: '/getting-started',
		name: 'Get Started',
		component: () => import(/* webpackChunkName: "started" */ '../views/getting-started/GettingStarted.vue')
	},
	{
		path: '/scan-settings',
		name: 'Scan settings',
		component: () => import(/* webpackChunkName: "threed" */ '../views/scan-settings/ScanSettings.vue')
	},
	{
		path: '/threed',
		name: '3D Scan',
		component: () => import(/* webpackChunkName: "threed" */ '../views/threed-scan/ThreeDScan.vue')
	},
	{
		path: '/landmarks',
		name: 'Landmark selection',
		component: () => import(/* webpackChunkName: "landmarks" */ '../views/LandmarkSelectionView.vue')
	},
	{
		path: '/results',
		name: 'Results',
		component: () => import(/* webpackChunkName: "results" */ '../views/results/Results.vue')
	},
	{
		path: '/order-styles',
		name: 'Orthotic Styles',
		component: () => import(/* webpackChunkName: "orderstyles" */ '../views/order-styles/OrderStyles.vue')
	},
	{
		path: '/prescription',
		name: 'Prescription',
		component: () => import(/* webpackChunkName: "prescription" */ '../views/prescription/PrescriptionView.vue')
	},
	{
		path: '/summary',
		name: 'Order Review',
		component: () => import(/* webpackChunkName: "summary" */ '../views/prescription/SummaryView.vue')
	},
	{
		path: '/end-view',
		name: 'Order',
		component: () => import(/* webpackChunkName: "endview" */ '../views/end-view/EndView.vue')
	},
	{
		path: '/patients',
		name: 'Patients',
		component: () => import(/* webpackChunkName: "patients" */ '../views/patient-table/PatientRecall.vue')
	},
	{
		path: '/landmark',
		name: 'Anatomical Markers',
		component: () => import(/* webpackChunkName: "patients" */ '../views/patient-table/PatientRecall.vue')
	},
	{
		path: '/index',
		name: 'Index',
		component: () => import(/* webpackChunkName: "index" */ '../views/index/Index.vue')
	},
	{
		path: '/onboard',
		name: 'Onboard',
		component: () => import(/* webpackChunkName: "onboard" */ '../views/onboard/Onboard.vue')
	},
	{
		path: '/saved-rx',
		name: 'Saved Rx',
		component: () => import(/* webpackChunkName: "onboard" */ '../views/saved-rx/SavedRx.vue')
	},
	{
		path: '/saved-rx-list',
		name: 'Saved Rx List',
		component: () => import(/* webpackChunkName: "onboard" */ '../views/saved-rx-list/SavedRxList.vue')
	},
	{
		path: 'privacy-policy',
		name: 'Privacy',
		component: () => import(/* webpackChunkName: "privacy" */ '../views/privacy-page/PrivacyPage.vue')
	},
	{
		path: 'usbagent',
		name: 'DownloadUsbAgent',
		component: () => import('../views/download/DownloadUsbAgent.vue')
	}
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
});

router.beforeEach(async (to, from, next) => {
	store.lastRoute = from.path;
	if (!to.query.code && to.query.id && to.query.id.includes('?code=')) {
		const id = to.query.id;
		to.query.id = to.query.id.toString().split('?')[0];
		to.query.code = id.toString().split('?code=')[1];
	}

	if (to.query.hide_close_button) {
		store.utils.mobileAppView = true;
	}
	if (to.query.code) {
		window.sessionStorage.setItem('code', to.query.code.toString());
		window.sessionStorage.setItem('state', to.query.state.toString());
		if (to.path.includes('landmark')) {
			next({ path: '/landmarks?id=' + to.query.id });
		} else {
			next({ path: '/' });
			return;
		}
	}

	if (sessionStorage.getItem('code')) {
		store.auth.connecting = true;
	}

	if (to.query.agenturi) {
		store.agent.setAgentUri(to.query['agenturi'] as string);
	}

	if (Object.keys(to.query).length > 0 && 'error' in to.query) {
		store.utils.error = true;
		if ('error_description' in to.query) {
			store.utils.errorInfo.description = to.query['error_description'] as string;
		}
		if ('error_details' in to.query) {
			store.utils.errorInfo.details = to.query['error_details'] as string;
		}
	}

	if (to.name === 'Onboard' || to.name === 'Privacy') {
		next();
		return;
	}

	if (to.name === 'DownloadUsbAgent') {
		next();
		return;
	}

	if (Object.keys(to.query).length > 0 && 'id' in to.query) {
		if ('id' in to.query) {
			if (store._patient.userRecordID !== to.query['id'] && typeof to.query['id'] === 'string') {
				await store.auth.waitForOperatorLoggedIn();
				if (to.query.order_id) {
					console.log('Order id: ', to.query.order_id);
					store._patient.openPatient(to.query['id'] as string, to.query.order_id as string);
				} else {
					store._patient.openPatient(to.query['id'] as string);
				}
			}
		} else if (to.path != '/index') {
			next('/patients');
			return;
		}
	}
	next();
	store.currentRoute = to.path;
});

router.afterEach(async (to, from) => {
	if (
		!('id' in to.query) &&
		store._patient.userRecordID === '' &&
		!['/', '/index', '/patients', '/getting-started', '/saved-rx', '/saved-rx-list', '/privacy-policy', '/usbagent'].includes(to.path) &&
		location.hostname !== 'localhost'
	) {
		await router.push('patients');
		return;
	}
});

export { routes };

export default router;
